import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { classNames } from "primereact/utils";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import Input from "../input/Input";
import InputText from "../other/InputText";
import { getTValue } from "../other/label";
import ApiService from "../service/apiService";
// import { alphanumericCheck, emailCheck, mobileNoValidation, numberCheckTel, toleCheck } from "../../helper/validationHelper";
// import { setBlockNoError, setEmailIdError, setMobileNoError, setPerBlockNoError, setPerTelephoneNoError, setPerToleError, setTelephoneNoError, setToleError } from "../../redux/addressSlice";
import { alphanumericCheck, checkAlphanumeric, checkWebsite, emailCheck, mobileNoValidation, number, numberCheck, numberCheckTel, toleCheck } from "../../helper/validationHelper";
import {
    setTelephoneNoError, setPerTelephoneNoError, setBlockNoError, setPerBlockNoError, setPerToleError, setToleError, setEmailIdError, setMobileNoError, setWebsiteError,
    setCountry,
    setState,
    setDistrict,
    setMunicipality,
    setWard,
    setPerCountry,
    setPerState,
    setPerDistrict,
    setPerMunicipality,
    setPerWard,
} from "../../redux/addressSlice";

import { useDispatch, useSelector } from "react-redux";


function getWardList(totalWard) {
    const wardList = [];
    for (let i = 1; i <= totalWard; i++) {
        wardList.push(i);
    }
    return wardList;
}

function AddressInput(props) {
    const { t, i18n } = useTranslation();
    const data = props.data || {};
    const errorObj = props.errorObj || {};

    // const getName = (name) => props.prefix
    //     ? props.prefix + name.charAt(0).toUpperCase() + name.substring(1)
    //     : name;
    const getName = (name) => props.prefix
        ? props.prefix + name.charAt(0).toUpperCase() + name.substring(1)
        : name;

    // Add nationality selector
    const nationality = useSelector((state) => state.personalDetails.nationality);
    const country = useSelector((state) => props.prefix === "per" ? state.addressDetails.perCountry : state.addressDetails.country);
    const state = useSelector((state) => props.prefix === "per" ? state.addressDetails.perState : state.addressDetails.state);
    const district = useSelector((state) => props.prefix === "per" ? state.addressDetails.perDistrict : state.addressDetails.district);
    const municipality = useSelector((state) => props.prefix === "per" ? state.addressDetails.perMunicipality : state.addressDetails.municipality);
    const ward = useSelector((state) => props.prefix === "per" ? state.addressDetails.perWard : state.addressDetails.ward);

    // const country = data[getName('country')];
    // const state = data[getName('state')];
    // const district = data[getName('district')];
    // const municipality = data[getName('municipality')];

    const [loadingc, setLoadingc] = useState(false);
    const [loadings, setLoadings] = useState(false);
    const [loadingd, setLoadingd] = useState(false);
    const [loadingm, setLoadingm] = useState(false);

    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [municipalityList, setMunicipalityList] = useState([]);
    const [wardList, setWardList] = useState([]);

    const toleError = useSelector((state) => state.addressDetails?.errors?.toleError || null);
    const perToleError = useSelector((state) => state.addressDetails?.errors?.perToleError || null);
    const blockNoError = useSelector((state) => state.addressDetails?.errors?.blockNoError || null);
    const perBlockNoError = useSelector((state) => state.addressDetails?.errors?.perBlockNoError || null);
    const telephoneNoError = useSelector((state) => state.addressDetails?.errors?.telephoneNoError || null);
    const perTelephoneNoError = useSelector((state) => state.addressDetails?.errors?.perTelephoneNoError || null);
    const emailIdError = useSelector((state) => state.addressDetails?.errors?.emailIdError || null);
    const mobileNoError = useSelector((state) => state.addressDetails?.errors?.mobileNoError || null);

    const dispatch = useDispatch();

    useEffect(() => {
        setLoadingc(true);
        ApiService.getCountryList().then((response) => {
            setCountryList(response.data.data);
        }).finally(() => setLoadingc(false));
    }, []);

    useEffect(() => {
        if (country) getStateListByCountryCode(country);

    }, [country]);

    useEffect(() => {
        if (state) getDistrictListByStateCode(state);
    }, [state]);

    useEffect(() => {
        if (district) getMunicipalityListByDistrictCode(district);
    }, [district]);

    useEffect(() => {
        if (municipality) generateWardList(municipality);
    }, [municipality, municipalityList.length]);

    function getStateListByCountryCode(param) {
        setLoadings(true);
        ApiService.getStateListByCountryCode(param).then((response) => {
            setStateList(response.data.data);
        }).finally(() => setLoadings(false));
    }

    function getDistrictListByStateCode(param) {
        setLoadingd(true);
        ApiService.getDistrictListByStateCode(param).then((response) => {
            setDistrictList(response.data.data);
        }).finally(() => setLoadingd(false));
    }

    function getMunicipalityListByDistrictCode(param) {
        setLoadingm(true);
        ApiService.getMunicipalityListByDistrictCode(param).then((response) => {
            setMunicipalityList(response.data.data);
        }).finally(() => setLoadingm(false));
    }

    const generateWardList = (param) => {
        const mun = municipalityList.find((m) => m.code === param);

        if (mun && mun.ward) setWardList(getWardList(mun.ward));
    }

    const {
        control,
        formState: { errors },
        setValue,
    } = useForm({});

    const getFormErrorMessage = (name) => {
        return (
            (errorObj[getName(name) + "Error"] && <small className="p-error">{errorObj[getName(name) + "Error"].message}</small>)
            || (errors[getName(name)] && <small className="p-error">{errors[getName(name)].message}</small>)
        );
    };

    // Auto-set country to "NP" when nationality is "NP"
    useEffect(() => {
        if (nationality === "NP" && (!country || country !== "NP")) {
            // Set the form value and dispatch Redux action
            setValue("country", "NP");
            dispatch(props.prefix === "per" ? setPerCountry("NP") : setCountry("NP"));
            // Clear dependent fields
            dispatch(props.prefix === "per" ? setPerState(null) : setState(null));
            dispatch(props.prefix === "per" ? setPerDistrict(null) : setDistrict(null));
            dispatch(props.prefix === "per" ? setPerMunicipality(null) : setMunicipality(null));
            dispatch(props.prefix === "per" ? setPerWard(null) : setWard(null));

            // Also trigger onChange to parent component
            if (props.onChange) {
                props.onChange({
                    [getName('country')]: "NP",
                    [getName('country') + 'Desc']: "Nepal"
                });
            }
        }
    }, [nationality, dispatch, setValue, props.prefix, country, props.onChange]);

    const onInputChange = (adata) => {
        props.onChange(adata);
    };

    return (
        <>
            <div className="p-grid p-fluid" style={{ margin: 0 }}>
                <div className="p-field p-col-6 p-md-4 stick-right">
                    <label className="p-col-6 p-md-6" htmlFor="country">
                        {t("country")}*
                    </label>
                    <Controller
                        name="country"
                        control={control}
                        rules={{ required: "Country is required." }}
                        render={({ field, fieldState }) => (
                            <Dropdown
                                id={field.id}
                                value={country}
                                filter
                                // showClear
                                // disabled={loadingc || props.disabled}
                                //     dropdownIcon={loadingc ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                                //     onChange={(e) => {
                                //         onInputChange({
                                //             [getName('country')]: e.value,
                                //             [getName('country') + 'Desc']: e.originalEvent.nativeEvent.target.ariaLabel
                                //         });
                                //         field.onChange(e.value);
                                //     }}
                                //     options={countryList}
                                //     optionLabel={(data) =>
                                //         getTValue(i18n, data.descEng, data.descNep)
                                //     }
                                //     placeholder={t("selectCountry")}
                                //     optionValue="code"
                                // />
                                showClear={nationality !== "NP"} // Disable clear when nationality is "NP"
                                disabled={loadingc || props.disabled || nationality === "NP"} // Disable dropdown when nationality is "NP"
                                dropdownIcon={loadingc ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                                onChange={(e) => {
                                    onInputChange({
                                        [getName('country')]: e.value,
                                        [getName('country') + 'Desc']: e.originalEvent.nativeEvent.target.ariaLabel
                                    });
                                    field.onChange(e.value);
                                    dispatch(props.prefix === "per" ? setPerCountry(e.value) : setCountry(e.value));
                                    // Clear dependent fields
                                    dispatch(props.prefix === "per" ? setPerState(null) : setState(null));
                                    dispatch(props.prefix === "per" ? setPerDistrict(null) : setDistrict(null));
                                    dispatch(props.prefix === "per" ? setPerMunicipality(null) : setMunicipality(null));
                                    dispatch(props.prefix === "per" ? setPerWard(null) : setWard(null));
                                }}
                                options={countryList}
                                optionLabel={(data) =>
                                    getTValue(i18n, data.descEng, data.descNep)
                                }
                                placeholder={t("selectCountry")}
                                optionValue="code"
                            />
                        )}
                    />
                    {getFormErrorMessage("country")}
                </div>

                {(!country || country === "NP") ? (
                    <>
                        <div className="p-field p-col-6 p-md-4 stick-left stick-right">
                            <label className="p-col-6 p-md-3" htmlFor="state">
                                {t("state")}*
                            </label>
                            <Controller
                                name="state"
                                control={control}
                                rules={{ required: "State is required." }}
                                render={({ field, fieldState }) => (
                                    <Dropdown
                                        id={field.id}
                                        value={state}
                                        filter
                                        showClear
                                        disabled={loadings || props.disabled}
                                        dropdownIcon={loadings ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                                        // onChange={(e) => {
                                        //     onInputChange({
                                        //         [getName('state')]: e.value,
                                        //         [getName('state') + 'Desc']: e.originalEvent.nativeEvent.target.ariaLabel
                                        //     });
                                        //     field.onChange(e.value);
                                        // }}
                                        onChange={(e) => {
                                            onInputChange({
                                                [getName('state')]: e.value,
                                                [getName('state') + 'Desc']: e.originalEvent.nativeEvent.target.ariaLabel
                                            });
                                            field.onChange(e.value);
                                            dispatch(props.prefix === "per" ? setPerState(e.value) : setState(e.value));
                                            // Clear dependent fields
                                            dispatch(props.prefix === "per" ? setPerDistrict(null) : setDistrict(null));
                                            dispatch(props.prefix === "per" ? setPerMunicipality(null) : setMunicipality(null));
                                            dispatch(props.prefix === "per" ? setPerWard(null) : setWard(null));
                                        }}
                                        options={stateList}
                                        optionLabel={(data) =>
                                            getTValue(i18n, data.descEng, data.descNep)
                                        }
                                        placeholder={t("selectState")}
                                        optionValue="code"
                                    />
                                )}
                            />
                            {getFormErrorMessage("state")}
                        </div>

                        <div className="p-field p-col-12 p-md-4 stick-left">
                            <label className="p-col-12 p-md-12" htmlFor="district">
                                {t("district")}*
                            </label>
                            <Controller
                                name="district"
                                control={control}
                                rules={{ required: "District is required." }}
                                render={({ field, fieldState }) => (
                                    <Dropdown
                                        id={field.id}
                                        filter showClear
                                        value={district}
                                        disabled={loadingd || props.disabled}
                                        dropdownIcon={loadingd ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                                        // onChange={(e) => {
                                        //     onInputChange({
                                        //         [getName('district')]: e.value,
                                        //         [getName('district') + 'Desc']: e.originalEvent.nativeEvent.target.ariaLabel
                                        //     });
                                        //     field.onChange(e.value);
                                        // }}
                                        onChange={(e) => {
                                            onInputChange({
                                                [getName('district')]: e.value,
                                                [getName('district') + 'Desc']: e.originalEvent.nativeEvent.target.ariaLabel
                                            });
                                            field.onChange(e.value);
                                            dispatch(props.prefix === "per" ? setPerDistrict(e.value) : setDistrict(e.value));
                                            // Clear dependent fields
                                            dispatch(props.prefix === "per" ? setPerMunicipality(null) : setMunicipality(null));
                                            dispatch(props.prefix === "per" ? setPerWard(null) : setWard(null));
                                        }}
                                        options={districtList}
                                        optionLabel={(data) =>
                                            getTValue(i18n, data.descEng, data.descNep)
                                        }
                                        placeholder={t("selectDistrict")}
                                        optionValue="code"
                                    />
                                )}
                            />
                            {getFormErrorMessage("district")}
                        </div>

                        <div className="p-field p-col-12 p-md-4 stick-right">
                            <label className="p-col-12 p-md-12" htmlFor="municipality">
                                {t("municipality")}*
                            </label>
                            <Controller
                                name="municipality"
                                control={control}
                                rules={{ required: "Municipality is required." }}
                                render={({ field, fieldState }) => (
                                    <Dropdown
                                        id={field.id}
                                        value={municipality}
                                        filter showClear
                                        disabled={loadingm || props.disabled}
                                        dropdownIcon={loadingm ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                                        // onChange={(e) => {
                                        //     onInputChange({
                                        //         [getName('municipality')]: e.value,
                                        //         [getName('municipality') + 'Desc']: e.originalEvent.nativeEvent.target.ariaLabel
                                        //     });
                                        //     field.onChange(e.value);
                                        // }}
                                        onChange={(e) => {
                                            onInputChange({
                                                [getName('municipality')]: e.value,
                                                [getName('municipality') + 'Desc']: e.originalEvent.nativeEvent.target.ariaLabel
                                            });
                                            field.onChange(e.value);
                                            dispatch(props.prefix === "per" ? setPerMunicipality(e.value) : setMunicipality(e.value));
                                            // Clear dependent fields
                                            dispatch(props.prefix === "per" ? setPerWard(null) : setWard(null));
                                        }}
                                        options={municipalityList}
                                        optionLabel={(data) =>
                                            getTValue(i18n, data.descEng, data.descNep)
                                        }
                                        placeholder={t("selectMunicipality")}
                                        optionValue="code"
                                    />
                                )}
                            />
                            {getFormErrorMessage("municipality")}
                        </div>

                        <div className="p-field p-col-12 p-md-2 stick-left stick-right">
                            <label className="p-col-12 p-md-12" htmlFor="ward">
                                {t("ward")}*
                            </label>
                            <Dropdown
                                editable
                                options={wardList}
                                value={data[getName('ward')]}
                                filter showClear
                                disabled={props.disabled}
                                onChange={(e) => {
                                    onInputChange({ [getName('ward')]: e.value });
                                    dispatch(props.prefix === "per" ? setPerWard(e.value) : setWard(e.value));
                                }}
                                placeholder={t("selectWard")}
                            />
                            {getFormErrorMessage("ward")}
                        </div>
                    </>
                ) : null}
                <div
                    className={
                        "p-field p-col-12 stick-left " +
                        ((!country || country === "NP") ? " stick-right p-md-4" : "p-md-8")
                    }
                >
                    <label className="p-col-12 p-md-12" htmlFor="tole">
                        {(!country || country === "NP") ? t("tole") : t("Complete Address")}*
                    </label>
                    {/* <Controller
                        name="tole"
                        control={control}
                        rules={{
                            required:
                                ((!country || country === "NP") ? "Tole" : "Complete Address") +
                                " is required.",
                        }}
                        render={({ field, fieldState }) => (
                            <InputText
                                id={field.name}
                                {...field}
                                value={data[getName('tole')]}
                                clearSpace
                                disabled={props.disabled}
                                keyfilter={/^[a-zA-Z0-9\.\,\\\(\) ]*$/}
                                placeholder={
                                    (!country || country === "NP") ? t("tole") : t("Complete Address")
                                }
                                onChange={(e) => onInputChange({ [getName("tole")]: e.target.value })}
                                className={classNames({ "p-invalid": fieldState.invalid })}
                            />
                        )}
                    />
                    {getFormErrorMessage("tole")} */}
                    <Controller
                        name={props.prefix === 'per' ? "perTole" : "tole"}
                        control={control}
                        rules={{
                            required:
                                ((!country || country === "NP") ? "Tole" : "Complete Address") +
                                " is required.",
                        }}
                        render={({ field, fieldState }) => {
                            return (
                                <InputText
                                    id={field.name}
                                    {...field}
                                    value={data[getName('tole')]}
                                    clearSpace
                                    disabled={props.disabled}
                                    keyfilter={/^[a-zA-Z0-9\s\-(),.]*$/}
                                    placeholder={
                                        (!country || country === "NP") ? t("tole") : t("Complete Address")
                                    }
                                    onChange={(e) => onInputChange({ [getName("tole")]: e.target.value })}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim(); // Trim to handle whitespace-only values
                                        if (props.prefix == 'per') {
                                            if (!value) {
                                                dispatch(setPerToleError({
                                                    message: "Tole field can't be empty.",
                                                    section: "perTole",
                                                }));
                                            }
                                            else if (!toleCheck(value)) {
                                                dispatch(setPerToleError({
                                                    message: "Tole required valid characters only.",
                                                    section: "perTole",
                                                }));
                                            }
                                            else {
                                                dispatch(setPerToleError({
                                                    message: null,
                                                    section: "perTole",
                                                }));
                                            }
                                        }
                                        else {
                                            if (!value) {
                                                dispatch(setToleError({
                                                    message: "Tole field can't be empty.",
                                                    section: "tole",
                                                }));
                                            }
                                            else if (!toleCheck(value)) {
                                                dispatch(setToleError({
                                                    message: "Tole required valid characters only",
                                                    section: "tole",
                                                }));
                                            }
                                            else {
                                                dispatch(setToleError({
                                                    message: null,
                                                    section: "tole",
                                                }));
                                            }
                                        }
                                    }}
                                    className={classNames({
                                        "p-invalid": fieldState.invalid || (props.prefix == 'per' ? (perToleError?.message && perToleError.message !== null) : (toleError?.message && toleError.message !== null)),
                                    })}
                                />
                            );
                        }
                        }
                    />
                    {props.prefix != 'per' ? getFormErrorMessage("tole") : getFormErrorMessage("tole")}
                </div>

                {(!country || country === "NP") && (
                    <div className="p-field p-col-12 p-md-2 stick-left">
                        <label className="p-col-12 p-md-12" htmlFor="blockNo">
                            {t("blockNo")}
                        </label>
                        {/* <Controller
                            name="blockNo"
                            control={control}
                            rules={{ required: "Block number is required." }}
                            render={({ field, fieldState }) => (
                                <Input
                                    id={field.name}
                                    {...field}
                                    disabled={props.disabled}
                                    placeholder={t("blockNo")}
                                    onChange={(e) => onInputChange({ [getName("blockNo")]: e.target.value })}
                                    value={data[getName('blockNo')]}
                                    className={classNames({ "p-invalid": fieldState.invalid })}
                                />
                            )}
                        />
                        {getFormErrorMessage("blockNo")} */}
                        <Controller
                            name="blockNo"
                            control={control}
                            rules={{ required: "Block number is required." }}
                            render={({ field, fieldState }) => {
                                return (
                                    <Input
                                        id={field.name}
                                        value={data[getName('blockNo')]}
                                        keyfilter={/^[a-zA-Z0-9]+$/}
                                        {...field}
                                        disabled={props.disabled}
                                        placeholder={t("blockNo")}
                                        onChange={(e) => onInputChange({ [getName("blockNo")]: e.target.value })}
                                        // onBlur={(e) => {
                                        //     const value = e.target.value.trim(); // Trim to handle whitespace-only values
                                        //     if (props.prefix == 'per') {
                                        //         if (!value) {
                                        //             dispatch(setPerBlockNoError({
                                        //                 message: "Block No. field can't be empty.",
                                        //                 section: "perBlockNo",
                                        //             }));
                                        //         }
                                        //         else if (!alphanumericCheck(value)) {
                                        //             dispatch(setPerBlockNoError({
                                        //                 message: "BlockNo is required in alpha numeric characters only",
                                        //                 section: "perBlockNo",
                                        //             }));
                                        //         }
                                        //         else {
                                        //             dispatch(setPerBlockNoError({
                                        //                 message: null,
                                        //                 section: "perBlockNo",
                                        //             }));
                                        //         }
                                        //     }
                                        //     else {
                                        //         if (!value) {
                                        //             dispatch(setBlockNoError({
                                        //                 message: "Block No. field can't be empty.",
                                        //                 section: "blockNo",
                                        //             }));
                                        //         }
                                        //         else if (!alphanumericCheck(value)) {
                                        //             dispatch(setBlockNoError({
                                        //                 message: "BlockNo is required in alpha numeric characters only.",
                                        //                 section: "blockNo",
                                        //             }));
                                        //         }
                                        //         else {
                                        //             dispatch(setBlockNoError({
                                        //                 message: null,
                                        //                 section: "blockNo",
                                        //             }));
                                        //         }
                                        //     }
                                        // }}
                                        onBlur={(e) => {
                                            const value = e.target.value.trim(); // Trim to handle whitespace-only values
                                            if (props.prefix == 'per') {
                                                if (value && !alphanumericCheck(value)) {
                                                    dispatch(setPerBlockNoError({
                                                        message: "BlockNo is required in alpha numeric characters only",
                                                        section: "perBlockNo",
                                                    }));
                                                } else {
                                                    dispatch(setPerBlockNoError({
                                                        message: null,
                                                        section: "perBlockNo",
                                                    }));
                                                }
                                            } else {
                                                if (value && !alphanumericCheck(value)) {
                                                    dispatch(setBlockNoError({
                                                        message: "BlockNo is required in alpha numeric characters only",
                                                        section: "blockNo",
                                                    }));
                                                } else {
                                                    dispatch(setBlockNoError({
                                                        message: null,
                                                        section: "blockNo",
                                                    }));
                                                }
                                            }
                                        }}

                                        className={classNames({
                                            "p-invalid": fieldState.invalid || (props.prefix == 'per' ? (perBlockNoError?.message && perBlockNoError.message !== null) : (blockNoError?.message && blockNoError.message !== null)),
                                        })}
                                    />
                                );
                            }
                            }
                        />
                        {props.prefix != 'per' ? getFormErrorMessage("blockNo") : getFormErrorMessage("blockNo")}
                    </div>
                )}
                {/* <div className="p-field p-col-12 p-md-3 stick-right">
                    <label className="p-col-12 p-md-12" htmlFor="telephoneNo">
                        {t("telephoneNo")}
                    </label>
                    <Controller
                        name="telephoneNo"
                        control={control}
                        rules={{ required: "Telephone Number is required." }}
                        render={({ field, fieldState }) =>
                            country !== "NP" ? (
                                <Input
                                    id={field.name}
                                    {...field}
                                    disabled={props.disabled}
                                    // keyfilter="num"
                                    keyfilter={/^\d+(-\d+)*$/}
                                    placeholder={t("telephoneNo")}
                                    onChange={(e) => onInputChange({ [getName("telephoneNo")]: e.target.value })}
                                    value={data[getName('telephoneNo')]}
                                    className={classNames({ "p-invalid": fieldState.invalid })}
                                />
                            ) : (
                                <InputMask
                                    mask="999999999"
                                    id={field.name}
                                    {...field}
                                    disabled={props.disabled}
                                    placeholder={t("telephoneNo")}
                                    onChange={(e) => onInputChange({ [getName("telephoneNo")]: e.target.value })}
                                    value={data[getName('telephoneNo')]}
                                    className={classNames({ "p-invalid": fieldState.invalid })}
                                />
                            )
                        }
                    />
                    {getFormErrorMessage("telephoneNo")}
                </div> */}
                <div className="p-field p-col-12 p-md-3 stick-right">
                    <label className="p-col-12 p-md-12" htmlFor="telephoneNo">
                        {t("telephoneNo")}
                    </label>
                    <Controller
                        name="telephoneNo"
                        control={control}
                        rules={{ required: "Telephone Number is required." }}
                        render={({ field, fieldState }) =>
                            country !== "NP" ? (
                                <Input
                                    id={field.name}
                                    {...field}
                                    disabled={props.disabled}
                                    value={data[getName("telephoneNo")]}
                                    // keyfilter="num"
                                    keyfilter={/^\d+(-\d+)*$/}
                                    placeholder={t("telephoneNo")}
                                    // onChange={(e) => onInputChange({ [getName("telephoneNo")]: e.target.value })}
                                    onChange={(e) => {
                                        onInputChange({ [getName("telephoneNo")]: e.target.value });
                                    }}
                                    // onBlur={(e) => {
                                    //     const value = e.target.value.trim();
                                    //     if (props.prefix === 'per') {
                                    //         if (!value) {
                                    //             dispatch(
                                    //                 setPerTelephoneNoError({
                                    //                     message: "Telephone Number can't be empty.",
                                    //                     section: "perTelephoneNo",
                                    //                 })
                                    //             );
                                    //         } else if (!numberCheckTel(value)) {
                                    //             dispatch(
                                    //                 setPerTelephoneNoError({
                                    //                     message: "Telephone Number must be numeric with optional dashes.",
                                    //                     section: "perTelephoneNo",
                                    //                 })
                                    //             );
                                    //         } else {
                                    //             dispatch(setPerTelephoneNoError({ message: null, section: "perTelephoneNo" }));
                                    //         }
                                    //     } else {
                                    //         if (!value) {
                                    //             dispatch(
                                    //                 setTelephoneNoError({
                                    //                     message: "Telephone Number can't be empty.",
                                    //                     section: "telephoneNo",
                                    //                 })
                                    //             );
                                    //         } else if (!numberCheckTel(value)) {
                                    //             dispatch(
                                    //                 setTelephoneNoError({
                                    //                     message: "Telephone Number must be numeric with optional dashes.",
                                    //                     section: "telephoneNo",
                                    //                 })
                                    //             );
                                    //         } else {
                                    //             dispatch(setTelephoneNoError({ message: null, section: "telephoneNo" }));
                                    //         }
                                    //     }
                                    // }}
                                    onBlur={(e) => {
                                        const value = e.target.value.trim(); // Trim to handle whitespace-only values
                                        if (props.prefix === 'per') {
                                            if (value && !numberCheckTel(value)) {
                                                dispatch(
                                                    setPerTelephoneNoError({
                                                        message: "Telephone Number must be numeric with optional dashes.",
                                                        section: "perTelephoneNo",
                                                    })
                                                );
                                            } else {
                                                dispatch(setPerTelephoneNoError({ message: null, section: "perTelephoneNo" }));
                                            }
                                        } else {
                                            if (value && !numberCheckTel(value)) {
                                                dispatch(
                                                    setTelephoneNoError({
                                                        message: "Telephone Number must be numeric with optional dashes.",
                                                        section: "telephoneNo",
                                                    })
                                                );
                                            } else {
                                                dispatch(setTelephoneNoError({ message: null, section: "telephoneNo" }));
                                            }
                                        }
                                    }}
                                    className={classNames({
                                        "p-invalid":
                                            fieldState.invalid ||
                                            (props.prefix === "per"
                                                ? perTelephoneNoError?.message
                                                : telephoneNoError?.message),
                                    })}
                                // className={classNames({ "p-invalid": fieldState.invalid })}
                                />
                            ) : (
                                <InputMask
                                    mask="99-9999999"
                                    id={field.name}
                                    {...field}
                                    value={data[getName("telephoneNo")]}
                                    disabled={props.disabled}
                                    placeholder={t("telephoneNo")}
                                    // onChange={(e) => onInputChange({ [getName("telephoneNo")]: e.target.value })}
                                    onChange={(e) => {
                                        onInputChange({ [getName("telephoneNo")]: e.target.value });
                                    }}
                                    // onBlur={(e) => {
                                    //     const value = e.target.value.trim();
                                    //     if (props.prefix === 'per') {
                                    //         if (!value) {
                                    //             dispatch(
                                    //                 setPerTelephoneNoError({
                                    //                     message: "Telephone Number can't be empty.",
                                    //                     section: "perTelephoneNo",
                                    //                 })
                                    //             );
                                    //         } else if (!numberCheckTel(value)) {
                                    //             dispatch(
                                    //                 setPerTelephoneNoError({
                                    //                     message: "Telephone Number must follow the format XX-XXXXXXX.",
                                    //                     section: "perTelephoneNo",
                                    //                 })
                                    //             );
                                    //         } else {
                                    //             dispatch(setPerTelephoneNoError({ message: null, section: "perTelephoneNo" }));
                                    //         }
                                    //     } else {
                                    //         if (!value) {
                                    //             dispatch(
                                    //                 setTelephoneNoError({
                                    //                     message: "Telephone Number can't be empty.",
                                    //                     section: "telephoneNo",
                                    //                 })
                                    //             );
                                    //         } else if (!numberCheckTel(value)) {
                                    //             dispatch(
                                    //                 setTelephoneNoError({
                                    //                     message: "Telephone Number must follow the format XX-XXXXXXX.",
                                    //                     section: "telephoneNo",
                                    //                 })
                                    //             );
                                    //         } else {
                                    //             dispatch(setTelephoneNoError({ message: null, section: "telephoneNo" }));
                                    //         }
                                    //     }
                                    // }}

                                    onBlur={(e) => {
                                        const value = e.target.value.trim(); // Trim to handle whitespace-only values
                                        if (props.prefix === 'per') {
                                            if (value && !numberCheckTel(value)) {
                                                dispatch(
                                                    setPerTelephoneNoError({
                                                        message: "Telephone Number must follow the format XX-XXXXXXX.",
                                                        section: "perTelephoneNo",
                                                    })
                                                );
                                            } else {
                                                dispatch(setPerTelephoneNoError({ message: null, section: "perTelephoneNo" }));
                                            }
                                        } else {
                                            if (value && !numberCheckTel(value)) {
                                                dispatch(
                                                    setTelephoneNoError({
                                                        message: "Telephone Number must follow the format XX-XXXXXXX.",
                                                        section: "telephoneNo",
                                                    })
                                                );
                                            } else {
                                                dispatch(setTelephoneNoError({ message: null, section: "telephoneNo" }));
                                            }
                                        }
                                    }}
                                    className={classNames({
                                        "p-invalid": fieldState.invalid || (props.prefix === "per" ? perTelephoneNoError?.message : telephoneNoError?.message),
                                    })}
                                // value={data[getName('telephoneNo')]}
                                // className={classNames({ "p-invalid": fieldState.invalid })}
                                />
                            )
                        }
                    />
                    {/* {getFormErrorMessage("telephoneNo")} */}
                    {props.prefix != 'per' ? getFormErrorMessage("telephoneNo") : getFormErrorMessage("telephoneNo")}
                </div>
                {!props.hide.emailId && <div className="p-field p-col-12 p-md-6 stick-left stick-right">
                    <label className="p-col-12 p-md-12" htmlFor="emailId">
                        {t("emailId")}*
                    </label>
                    {/* <Controller
                        name="emailId"
                        control={control}
                        rules={{ required: "Email Id is required." }}
                        render={({ field, fieldState }) => (
                            <Input
                                id={field.name}
                                {...field}
                                disabled={props.disabled}
                                keyfilter="email"
                                placeholder={t("emailId")}
                                onChange={(e) => onInputChange({ [getName("emailId")]: e.target.value })}
                                value={data[getName('emailId')]}
                                className={classNames({ "p-invalid": fieldState.invalid })}
                            />
                        )}
                    />
                    {getFormErrorMessage("emailId")} */}
                    <Controller
                        name="emailId"
                        control={control}
                        rules={{ required: "Email Id is required." }}
                        render={({ field, fieldState }) => (
                            <Input
                                id={field.name}
                                {...field}
                                disabled={props.disabled}
                                value={data[getName('emailId')]}
                                keyfilter="email"
                                // keyfilter={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
                                placeholder={t("emailId")}
                                onChange={(e) => onInputChange({ [getName("emailId")]: e.target.value })}
                                onBlur={(e) => {
                                    const value = e.target.value.trim(); // Trim to handle whitespace-only values
                                    if (!value) {
                                        dispatch(setEmailIdError({
                                            message: "Email Id field can't be empty.",
                                            section: "AD",
                                        }));
                                    }
                                    else if (!emailCheck(value)) {
                                        dispatch(setEmailIdError({
                                            message: "Valid Email Id is required.",
                                            section: "AD",
                                        }));
                                    }
                                    else {
                                        dispatch(setEmailIdError({
                                            message: null,
                                            section: "AD",
                                        }));
                                    }
                                }}
                                className={classNames({
                                    "p-invalid": fieldState.invalid || emailIdError?.message,
                                })}
                            />
                        )}
                    />
                    {getFormErrorMessage("emailId")}
                </div>}

                {!props.hide.mobileNo && <div className="p-field p-col-12 p-md-3 stick-left">
                    <label className="p-col-12 p-md-12" htmlFor="mobileNo">
                        {t("mobileNo")}*
                    </label>
                    {/* <Controller
                        name="mobileNo"
                        control={control}
                        rules={{ required: "Mobile Number is required." }}
                        render={({ field, fieldState }) => (
                            <PhoneInput
                                country={
                                    country && country.toLowerCase() && country.toLowerCase()
                                }
                                id={field.name}
                                {...field}
                                disabled={props.disabled}
                                value={data[getName('mobileNo')]}
                                onChange={(val) => onInputChange({ [getName("mobileNo")]: val })}
                                className={classNames({ "p-invalid": fieldState.invalid })}
                            />
                        )}
                    />
                    {getFormErrorMessage("mobileNo")} */}
                    <Controller
                        name="mobileNo"
                        control={control}
                        rules={{
                            required: "Mobile Number is required.",
                            validate: (value) => {
                                if (!mobileNoValidation(value, country === "NP" ? "977" : "")) {
                                    return country === "NP"
                                        ? "Mobile Number must contain 10 digits."
                                        : "Invalid Mobile Number.";
                                }
                                return true;
                            }
                        }}
                        render={({ field, fieldState }) => (
                            <PhoneInput
                                country={country?.toLowerCase()}
                                id={field.name}
                                {...field}
                                disableDropdown={true}
                                inputProps={{
                                    maxLength: country === "NP" ? 17 : 25,
                                }}
                                disabled={props.disabled}
                                value={data[getName('mobileNo')]}
                                onChange={(val) => onInputChange({ [getName("mobileNo")]: val })}
                                onBlur={(e) => {
                                    const value = e.target.value.trim();
                                    if (!value) {
                                        dispatch(setMobileNoError({
                                            message: "Mobile Number can't be empty.",
                                            section: "AD",
                                        }));
                                    } else if (!mobileNoValidation(value, country === "NP" ? "977" : "")) {
                                        dispatch(setMobileNoError({
                                            message: country === "NP"
                                                ? "Mobile Number must contain 10 digits."
                                                : "Invalid Mobile Number.",
                                            section: "AD",
                                        }));
                                    } else {
                                        dispatch(setMobileNoError({
                                            message: null,
                                            section: "AD",
                                        }));
                                    }
                                }}
                                className={classNames({
                                    "p-invalid": fieldState.invalid || (mobileNoError?.message && mobileNoError?.section === "AD")
                                })}
                            />
                        )}
                    />
                    {mobileNoError?.message && mobileNoError?.section === "AD" && (
                        <small className="p-error">{mobileNoError.message}</small>
                    )}
                </div>}

                {!props.hide.website && (
                    <div className="p-field p-col-12 p-md-12">
                        <label className="p-col-12 p-md-12" htmlFor="website">
                            {t("website")}
                        </label>
                        <Controller
                            name="website"
                            control={control}
                            render={({ field, fieldState }) => (
                                <InputText
                                    id={field.name}
                                    {...field}
                                    disabled={props.disabled}
                                    // keyfilter="email"
                                    placeholder={t("Website")}
                                    onChange={(e) => onInputChange({ [getName("website")]: e.target.value })}

                                    onBlur={(e) => {
                                        const value = e.target.value.trim(); // Trim to handle whitespace-only values
                                        if (value && !checkWebsite(value)) {
                                            dispatch(setWebsiteError({
                                                message: "Website contain invalid character, provide valid Website",
                                                section: "AD",
                                            }));
                                        } else {
                                            dispatch(setWebsiteError({
                                                message: null,
                                                section: "AD",
                                            }));
                                        }
                                    }}
                                    value={data[getName('website')]}
                                    keyfilter={/^[a-zA-Z0-9.]+$/}
                                    className={classNames({ "p-invalid": fieldState.invalid })}
                                />
                            )}
                        />
                        {getFormErrorMessage("website")}
                    </div>
                )}
                {!props.hide.fax && (<div className="p-field p-col-12 p-md-3">
                    <label className="p-col-12 p-md-12" htmlFor="fax">
                        {t("fax")}
                    </label>
                    <Controller
                        name="fax"
                        control={control}
                        rules={{ required: "Fax is required." }}
                        render={({ field, fieldState }) => (
                            <Input
                                id={field.name}
                                {...field}
                                placeholder={t("fax")}
                                onChange={(e) => onInputChange({ [getName("fax")]: e.target.value })}
                                value={data[getName('fax')]}
                                className={classNames({ "p-invalid": fieldState.invalid })}
                            />
                        )}
                    />
                    {getFormErrorMessage("fax")}
                </div>)}
            </div>
        </>
    );
}

export default AddressInput;
